import { CellProps, useWSysHub, useWSysPage, useWSysPath, WSysPage, WSysTable, WSysVert } from "@coimbra-its/websys-ux-core";
import { useKonyveloApi } from "../../store/konyvelo.api";
import { KonnyuRiport } from "./KonnyuRiport";
import { KonnyuOptionsSelect } from "./KonnyuOptionsSelect";
import { useState } from "react";

export const CELLS: CellProps<{ ID: number, RIPORTNEV: string }>[] = [
    { 'title': 'Riport', elem: (row) => row.RIPORTNEV, charWidth: 30 },
];


export function KonnyuReportSelect() {

    const path = useWSysPath();
    const [q] = path.useParam('q');


    const page = useWSysPage({ title: 'Könnyű riport', maxCols:2});
    const api = useKonyveloApi();
    const [result, hub] = api.konnyuReportGet.useData({q});
    const reports = result?.reportList || [];

    const reportPath = path.useChildRow('', reports, report => report.ID);    
    

    return <WSysPage page={page} hubs={[hub]} >
        <WSysVert mode="static">       
        </WSysVert>
        <WSysVert mode="rest">
            <WSysTable
                rows={reports}
                cells={CELLS}
                {...reportPath.forTable}
                
            />
        </WSysVert>
        {reportPath.on(reportPath.forTable.selectedRow && <KonnyuRiport  
            riportRow={reportPath.forTable.selectedRow}  
            />)}
    </WSysPage>
}